import { useQuery } from "@tanstack/react-query";

import { queryKeys } from "@/lib/query-keys";
import { stockService } from "@/services/stock";

import type { GetStockCardReq } from "@artisancode/api-types";

export function useStockCard(
  itemType: string,
  itemId: string,
  params?: Partial<GetStockCardReq>,
) {
  return useQuery({
    queryKey: queryKeys.stocks.card(
      itemType,
      itemId,
      params as Record<string, unknown>,
    ),
    queryFn: () => stockService.card(itemType, itemId, params),
    enabled: Boolean(itemType && itemId),
  });
}
